var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
/**
 * Modal styles — centered overlay with backdrop
 */
export const modalStyles = {
    backdrop: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modal: {
        backgroundColor: '#ffffff',
        borderRadius: '6px',
        boxShadow: '0 6px 30px rgba(0, 0, 0, 0.25)',
        minWidth: '340px',
        maxWidth: '440px',
        width: '90vw',
        maxHeight: '70vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        animation: 'fadeIn 0.15s ease-out',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 20px',
        borderBottom: '1px solid #edebe9',
        backgroundColor: '#faf9f8',
    },
    dateLabel: {
        fontSize: '16px',
        fontWeight: 600,
        color: '#323130',
    },
    closeButton: {
        background: 'none',
        border: 'none',
        fontSize: '22px',
        color: '#605e5c',
        cursor: 'pointer',
        padding: '2px 6px',
        lineHeight: 1,
        borderRadius: '4px',
    },
    content: {
        flex: 1,
        overflow: 'auto',
        padding: '12px 0',
    },
    noEvents: {
        padding: '24px 20px',
        textAlign: 'center',
        color: '#605e5c',
        fontSize: '14px',
    },
    eventsList: {
        display: 'flex',
        flexDirection: 'column',
    },
    eventRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '6px 20px',
        gap: '8px',
    },
    eventItem: {
        padding: '0',
        flex: 1,
        cursor: 'pointer',
        transition: 'background-color 0.1s ease',
    },
    deleteButton: {
        background: 'none',
        border: '1px solid #c8c6c4',
        borderRadius: '2px',
        color: '#a4262c',
        cursor: 'pointer',
        fontSize: '12px',
        lineHeight: 1,
        minWidth: '24px',
        minHeight: '24px',
    },
    footer: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '8px',
        padding: '14px 20px',
        borderTop: '1px solid #edebe9',
        backgroundColor: '#faf9f8',
    },
    actionButton: {
        background: 'none',
        border: '1px solid #8a8886',
        borderRadius: '2px',
        padding: '8px 16px',
        fontSize: '13px',
        color: '#323130',
        cursor: 'pointer',
        transition: 'all 0.1s ease',
    },
};
export default modalStyles;
//# sourceMappingURL=CalendarPopup.styles.js.map